import { TEMP_AI_MESSAGE_ID } from "@/models/conversation/Message";

/** Hide the list temp bubble when LatestMessageBubble owns the in-flight stream. */
export const shouldHideTempAiMessageInList = (
  messageId: string,
  latestMessageConversationId: string | undefined,
  selectedConversationId: string | undefined
): boolean => {
  if (messageId !== TEMP_AI_MESSAGE_ID) {
    return false;
  }

  return (
    latestMessageConversationId != null &&
    latestMessageConversationId === selectedConversationId
  );
};
